import styled from "styled-components/native";
import Text from ".";
import { text } from "../theme";

export const TinyText = styled(Text)`
  font-size: ${text.tiny.size};
  line-height: ${text.tiny.lineHeight};
`;
